import React from "react";
import { useTranslation } from "react-i18next";

const TimeSelector = ({ label, value, onChange, required = false }) => {
  const { t } = useTranslation();

  const times = Array.from({ length: 24 * 4 }, (_, i) => {
    const h = String(Math.floor(i / 4)).padStart(2, "0");
    const m = String((i % 4) * 15).padStart(2, "0");
    return `${h}:${m}`;
  });

  return (
    <div className="w-full text-primary py-2">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}

        {required && (
          <span className="text-muted ml-1">{t("modal.required")}</span>
        )}
        {!required && (
          <span className="text-muted ml-1">{t("modal.optional")}</span>
        )}
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full text-center text-base md:text-md border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition max-h-[200px] overflow-y-auto appearance-none"
        >
          <option value="">{t("calendar.selectTime")}</option>

          {times.map((time) => (
            <option key={time} value={time}>
              {time}
            </option>
          ))}
        </select>

        {/* Chevron / Icône de dropdown */}
        <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
          <svg
            className="w-5 h-5 text-gray-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default TimeSelector;
